
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Pumetolavasacity() {



    const cardData =
    {
        keyword: ' Pune to Lavasa city cabs',
        heading: 'Mauli Cabs: Pune to Lavasa city cabs ',
        headingDescription: 'Mauli Cabs offers reliable and comfortable Pune to Lavasa city cabs, ensuring a scenic and stress-free journey to the picturesque hill station of Lavasa. Whether you are heading for a relaxing getaway, a weekend trip, or exploring the city Is unique architecture and landscapes, we provide a range of vehicles including sedans, SUVs, and premium cars to meet your needs. With professional drivers, transparent pricing, no hidden charges, and a focus on customer satisfaction, Mauli Cabs guarantees a smooth and enjoyable ride from Pune to Lavasa.',

        top: 'Top Places to Visit in Lavasa with Mauli Cabs',

"topPlaces": [
    {
        "title": "Lavasa Lake",
        "description": "Lavasa Lake is the central attraction of Lavasa city, offering a picturesque setting for various water activities such as boating and kayaking. The lake is surrounded by hills, making it a perfect spot for relaxation and nature walks."
    },
    {
        "title": "Temghar Dam",
        "description": "Temghar Dam is located near Lavasa and offers stunning views of the surrounding hills and water. It is a great spot for photography and enjoying the serene environment."
    },
    {
        "title": "Panshet Dam",
        "description": "Panshet Dam, located around 15 km from Lavasa, is a popular destination for water sports and picnics. The dam's scenic surroundings make it a relaxing getaway for visitors."
    },
    {
        "title": "Lavasa Promenade",
        "description": "The Lavasa Promenade is a beautifully landscaped walkway along the waterfront, ideal for an evening stroll or a leisurely bike ride. The area is lined with cafes, offering a great place to unwind."
    },
    {
        "title": "Dasve Viewpoint",
        "description": "Dasve Viewpoint offers a panoramic view of Lavasa city and the surrounding hills. It's a popular spot for sightseeing and photography, especially during sunrise and sunset."
    },
    {
        "title": "Lavasa Adventure Park",
        "description": "Lavasa Adventure Park offers a variety of outdoor activities such as zip-lining, rock climbing, and trekking. It’s a great place for adventure enthusiasts looking for an adrenaline rush."
    },
    {
        "title": "Varasgaon Dam",
        "description": "Varasgaon Dam is located about 22 km from Lavasa and is a peaceful spot surrounded by lush greenery. The dam is often visited by nature lovers and offers a calm escape from the city."
    },
    {
        "title": "Venture Park",
        "description": "Venture Park in Lavasa offers a variety of recreational activities, including boating, cycling, and a range of adventure sports. It’s a family-friendly location with something for everyone."
    },
    {
        "title": "Lavasa Hilltop",
        "description": "Lavasa Hilltop offers a fantastic view of the entire Lavasa city. It is an excellent spot for sightseeing and taking in the natural beauty of the surrounding landscapes."
    },
    {
        "title": "Lavasa Marketplace",
        "description": "Lavasa Marketplace is a charming area filled with boutiques, restaurants, and cafes. It’s a great place to shop for local souvenirs, enjoy a meal, or simply relax in a pleasant atmosphere."
    }
],

"services": [
    {
      "name": "Pune to Lavasa Taxi",
      "description": "Book a comfortable taxi ride from Pune to Lavasa. Enjoy a scenic journey to the beautiful hill station with professional drivers."
    },
    {
      "name": "Pune to Lavasa Cab Services",
      "description": "Reliable and affordable cab services for your trip from Pune to Lavasa. Choose from a range of vehicles for a smooth travel experience."
    },
    {
      "name": "Pune to Lavasa Taxi Booking",
      "description": "Easily book a taxi from Pune to Lavasa with online booking. Choose the best option that suits your needs, whether a standard or luxury vehicle."
    },
    {
      "name": "Taxi from Pune to Lavasa",
      "description": "Enjoy a comfortable and scenic taxi ride from Pune to Lavasa, available with flexible booking options."
    },
    {
      "name": "Cab Services Pune to Lavasa",
      "description": "Choose from a variety of cab services, including Innova, Sedan, and Tempo Traveller for your trip to Lavasa from Pune."
    },
    {
      "name": "Pune to Lavasa Private Car",
      "description": "Book a private car for a peaceful and comfortable journey from Pune to Lavasa. Ideal for families or small groups looking for privacy."
    },
    {
      "name": "Pune to Lavasa Chauffeur Service",
      "description": "Avail chauffeur-driven services for a luxury and stress-free ride from Pune to Lavasa. Relax and enjoy the scenic views."
    },
    {
      "name": "Pune to Lavasa Airport Taxi",
      "description": "Book a convenient taxi from Pune Airport to Lavasa, ensuring a comfortable and timely arrival at your destination."
    },
    {
      "name": "Pune to Lavasa Taxi",
      "description": "Affordable and efficient taxi services from Pune to Lavasa. Choose from a variety of vehicles based on your needs."
    },
    {
      "name": "Pune to Lavasa Cab",
      "description": "Hire a cab for your trip from Pune to Lavasa, with professional drivers and a range of vehicle options to choose from."
    },
    {
      "name": "Pune Airport to Lavasa Taxi Fare",
      "description": "Check out the affordable taxi fare from Pune Airport to Lavasa. Enjoy a smooth and comfortable ride to your destination."
    },
    {
      "name": "Pune to Lavasa Cab Booking",
      "description": "Book your Pune to Lavasa cab online easily with flexible payment and booking options."
    },
    {
      "name": "Pune to Lavasa Cab Fare",
      "description": "Get the best prices for your cab ride from Pune to Lavasa, with no hidden charges."
    },
    {
      "name": "Pune to Lavasa Cab Price",
      "description": "Affordable pricing for your taxi journey from Pune to Lavasa. Various packages are available depending on the vehicle type and distance."
    },
    {
      "name": "Pune to Lavasa Taxi Fare",
      "description": "Competitive pricing for taxi services from Pune to Lavasa. Book your ride now and enjoy a cost-effective and comfortable trip."
    },
    {
      "name": "Pune to Lavasa Innova Taxi",
      "description": "Travel from Pune to Lavasa in the comfort of an Innova taxi, perfect for families or small groups."
    },
    {
      "name": "Pune to Lavasa Tempo Traveller on Rent",
      "description": "Rent a Tempo Traveller for your group journey from Pune to Lavasa. Ideal for larger groups seeking comfort and space."
    },
    {
      "name": "Pune to Lavasa Innova Crysta on Rent",
      "description": "Hire an Innova Crysta for your trip from Pune to Lavasa. Enjoy luxury and comfort in a spacious ride."
    },
    {
      "name": "Pune to Lavasa Cab Package",
      "description": "Choose from various Pune to Lavasa cab packages. Tailor your travel experience with options for one-way, round trip, or group packages."
    }
  ],
  "tableData": [
    ["Pune to Lavasa Taxi", "Pune to Lavasa Cab Services"],
    ["Pune to Lavasa Taxi Booking", "Taxi from Pune to Lavasa"],
    ["Cab Services Pune to Lavasa", "Pune to Lavasa Private Car"],
    ["Pune to Lavasa Chauffeur Service", "Pune to Lavasa Airport Taxi"],
    ["Pune to Lavasa Taxi", "Pune to Lavasa Cab"],
    ["Pune Airport to Lavasa Taxi Fare", "Pune to Lavasa Cab Booking"],
    ["Pune to Lavasa Cab Fare", "Pune to Lavasa Cab Price"],
    ["Pune to Lavasa Taxi Fare", "Pune to Lavasa Innova Taxi"],
    ["Pune to Lavasa Tempo Traveller on Rent", "Pune to Lavasa Innova Crysta on Rent"],
    ["Pune to Lavasa Cab Package", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Reliable and Timely Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and timely service for your Pune to Lavasa City journey. Whether you’re planning a relaxing getaway or a quick trip, our professional drivers ensure timely pickups and drop-offs, making your journey to Lavasa smooth and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "We offer a variety of comfortable and spacious vehicles for your Pune to Lavasa trip. From air-conditioned sedans to roomy SUVs, our vehicles are designed to ensure a comfortable and relaxing ride, making your trip to Lavasa a pleasant experience."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our experienced drivers are familiar with the route from Pune to Lavasa. They ensure a smooth, safe, and enjoyable ride, taking the best routes to avoid traffic, so you can relax and enjoy the scenic beauty of Lavasa."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs provides affordable and transparent pricing for your Pune to Lavasa City cab. We offer clear, upfront pricing with no hidden charges, ensuring that you get the best value for your journey while enjoying a comfortable ride."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Safety is our priority. All our vehicles are equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and smooth ride from Pune to Lavasa."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Mauli Cabs is available 24/7 for your Pune to Lavasa journey. Whether you're booking an early morning ride or a late-night return, our customer service team is always ready to assist you with your booking at any time."
    },
    {
        "WhyChooseheading": "Easy and Hassle-Free Booking",
        "WhyChoosedescription": "Booking your Pune to Lavasa cab with Mauli Cabs is quick and easy. You can book your ride online through our website or mobile app, or reach out to our customer service team for personalized assistance to ensure a smooth and hassle-free experience."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "Mauli Cabs offers customized travel packages for your Pune to Lavasa trip. Whether you're visiting for a weekend getaway, family vacation, or a business trip, we can tailor the service to meet your specific needs, ensuring a comfortable and enjoyable journey."
    }
]





















    }


    const faqData = [
        {
            question: 'How do I book a cab from Pune to Lavasa City with Mauli Cabs?',
            answer: 'Booking a cab from Pune to Lavasa City with Mauli Cabs is simple! You can book directly through our website or mobile app by entering "Pune" as your pickup location and "Lavasa City" as your destination. Select your preferred vehicle, confirm the booking, and you’re all set. Alternatively, you can contact our customer support team for assistance.',
        },
        {
            question: 'What types of cabs are available for the Pune to Lavasa City trip?',
            answer: 'Mauli Cabs offers a range of vehicles for your Pune to Lavasa City journey, including Sedans, SUVs, Ertiga, Innova Crysta, and premium options. You can choose the vehicle that best suits your comfort, space, and budget requirements.',
        },
        {
            question: 'Is the fare for the Pune to Lavasa City trip fixed?',
            answer: 'Yes, the fare for the Pune to Lavasa City trip is fixed and transparent. It includes all charges such as tolls, taxes, driver fees, and other applicable charges. There are no hidden costs, and the total fare is provided upfront when confirming your booking.',
        },
        {
            question: 'Can I book a round trip for the Pune to Lavasa City journey?',
            answer: 'Yes, you can easily book a round trip from Pune to Lavasa City. Simply provide your return details while making the booking, and we will ensure that your return journey is as smooth and comfortable as the onward trip.',
        },
        {
            question: 'How long does the journey from Pune to Lavasa City take?',
            answer: 'The journey from Pune to Lavasa City typically takes about 1.5 to 2 hours, depending on traffic and road conditions. The scenic drive through the hills and valleys adds to the overall enjoyment of the trip.',
        },
        {
            question: 'Are the drivers experienced for the Pune to Lavasa City trip?',
            answer: 'Yes, all Mauli Cabs drivers are professional, experienced, and familiar with the best routes to Lavasa City. They are trained to prioritize your safety and comfort during the journey.',
        },
        {
            question: 'Can I make stops during my journey from Pune to Lavasa City?',
            answer: 'Yes, you can make stops during the journey from Pune to Lavasa City for refreshments, meals, or sightseeing. Our drivers will accommodate any requests and ensure a comfortable and enjoyable experience.',
        },
        {
            question: 'Are the cabs air-conditioned and well-maintained for the Pune to Lavasa City trip?',
            answer: 'Yes, all our cabs are air-conditioned and regularly maintained for cleanliness and comfort. We ensure that you enjoy a smooth, pleasant, and relaxing ride throughout your journey to Lavasa City.',
        },
        {
            question: 'Can I cancel or modify my booking for the Pune to Lavasa City trip?',
            answer: 'Yes, you can easily cancel or modify your booking for the Pune to Lavasa City trip. We offer a flexible cancellation and modification policy through our website or app, and our customer support team is always ready to assist you.',
        },
        {
            question: 'Why should I choose Mauli Cabs for my Pune to Lavasa City trip?',
            answer: 'Mauli Cabs offers competitive pricing, a variety of vehicle options, professional drivers, and a commitment to ensuring your safety, comfort, and timely arrival at Lavasa City. Whether you Are traveling for business, leisure, or a weekend getaway, we ensure a stress-free and enjoyable ride.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rakesh Patel",
            position: "Tourist",
            text: "I booked a cab from Pune to Lavasa City with Mauli Cabs, and it was a great experience. The driver was professional and knew the best routes. The vehicle was comfortable, and the entire journey was smooth. I had a fantastic time exploring Lavasa City, and I’ll definitely book with Mauli Cabs again.",
            image: "/img/testimonial/testimonial-thumb-1-1.png",
        },
        {
            name: "Miss. Priya Desai",
            position: "Traveler",
            text: "The Pune to Lavasa City trip with Mauli Cabs was amazing! The ride was very comfortable, and the driver was very courteous. We had some scenic stops along the way, and the drive was truly enjoyable. I highly recommend Mauli Cabs for anyone looking for a comfortable ride to Lavasa City.",
            image: "/img/testimonial/testimonial-thumb-1-2.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Pune to Lavasa City Cabs by Mauli Cabs",
        "description": "Mauli Cabs provides reliable and comfortable taxi services for your journey from Pune to Lavasa City. Choose from private cars, Innova Crysta, or even a Tempo Traveller for group travel. Enjoy convenient booking options, affordable fares, and luxurious services for a scenic trip to Lavasa.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.7",
          "ratingCount": "4100"
        }
      };
     
      
   


    return (
        <div>
            <GTag/>
 
 <Helmet>
        <title>Pune to Lavasa City Cabs | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book your Pune to Lavasa city cabs with Mauli Cabs. We offer reliable taxi services with a variety of vehicles including private cars, Innova Crysta, and Tempo Travellers for groups. Enjoy affordable rates and a comfortable ride to Lavasa."
        />
        <meta
          name="keywords"
          content="Pune to Lavasa Taxi, Pune to Lavasa Cab Services, Pune to Lavasa Taxi Booking, Taxi from Pune to Lavasa, Cab Services Pune to Lavasa, Pune to Lavasa Private Car, Pune to Lavasa Chauffeur Service, Pune to Lavasa Airport Taxi, Pune to Lavasa Cab, Pune Airport to Lavasa Taxi Fare, Pune to Lavasa Cab Booking, Pune to Lavasa Cab Fare, Pune to Lavasa Cab Price, Pune to Lavasa Taxi Fare, Pune to Lavasa Innova Taxi, Pune to Lavasa Tempo Traveller on Rent, Pune to Lavasa Innova Crysta on Rent, Pune to Lavasa Cab Package"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>



            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/45.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Pumetolavasacity;